import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';

const StyledButton = withStyles((theme) => ({
  root: {
    padding: '6px 24px',
    background: theme.palette.grey[200],
    borderRadius: 3,
    border: 0,
  },
  label: {
    textTransform: 'none',
  },
}))(Button);

export const PrimaryButton = withStyles((theme) => ({
  root: {
    padding: '6px 24px',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 3,
    border: 0,
    // Add hover effects of green button
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
  label: {
    textTransform: 'none',
  },
}))(Button);

export default StyledButton;
